import { useState, useEffect } from "react";
import { fetch, post } from "src/common/networks/api-helper";
import { URL_PATHS } from "src/common/networks/url-paths";
import {
  TransactionReportList,
  MultiTransactionReportData,
} from "src/libraries/types/report-transaction";
import { ENUM_STATUS_NUMBER } from "src/libraries/enums/constant";
export const TransactionReportApdapter = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedTransaction, setSelectedTransaction] =
    useState<MultiTransactionReportData>();
  const [transactionList, setTransactionList] = useState<
    MultiTransactionReportData[]
  >([]);
  const [filters, setFilters] = useState({
    status: "ALL",
    searchText: "",
    dateRange: [],
    inputText: "",
  });
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(6);
  const [total, setTotal] = useState<number>(0);
  const handleFilterChange = (key: any, value: any) => {
    setFilters((prev) => {
      switch (key) {
        case "status":
          if (value === "ALL") {
            return { ...prev, status: "Tất cả", searchText: "", inputText: "" };
          }
          return { ...prev, status: value, searchText: value, inputText: "" };
        case "billNumber":
          return {
            ...prev,
            status: "Tất cả",
            searchText: value,
            inputText: value,
          };
        default:
          return { ...prev, [key]: value };
      }
    });
  };

  const handleSearch = (type: string) => {
    const { status, searchText, dateRange } = filters;
    const [start, end]: any[] = dateRange;

    const rangeStartString = start ? start.format("YYYY-MM-DDTHH:mm") : "";

    const rangeEndString = end ? end.format("YYYY-MM-DDTHH:mm") : "";
    let payload = {
      page: type === "paginate" ? currentPage : 1,
      size: pageSize,
      search: searchText,
      startDate: rangeStartString,
      endDate: rangeEndString,
    };
    getListTransaction(payload);
  };

  useEffect(() => {
    handleSearch("paginate");
  }, [currentPage, pageSize]);

  const getListTransaction = (payload: any) => {
    setLoading(true);
    fetch(URL_PATHS.GET_LIST_TRANSACTION, payload, false)
      .then((res) => {
        if (res) {
          setTransactionList(res?.data?.data);
          setTotal(res?.data?.totalElements);
          setLoading(false);
        }
      })
      .catch((e) => {
        //errorFromAPI(e.response.data.code, e.response.data.message);
        console.log("ERROR GET LIST TRANSACTION", e);
      });
  };
  const showModal = (record: any) => {
    setSelectedTransaction(record);
    setIsModalVisible(true);
  };
  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return {
    loading,
    isModalVisible,
    selectedTransaction,
    showModal,
    handleOk,
    handleCancel,
    transactionList,
    handleFilterChange,
    handleSearch,
    filters,
    currentPage,
    pageSize,
    total,
    setPageSize,
    setCurrentPage,
  };
};
